import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';

import { TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import 'assets/scss/soonoGetStarted.css';
import { getSelectedPlan } from 'constants/localStorageManager';
import { PLANS } from 'constants/plans';

import 'react-circular-progressbar/dist/styles.css';

const CircularStepIndicator = ({ step, activeStepNumber, steps }) => {
  const selectedPlan = getSelectedPlan() || {};
  const isTrialSelected = selectedPlan.plan_name === PLANS.FREE;
  const hidePlanDetails = isTrialSelected || !selectedPlan.plan_name;

  const percentage = (activeStepNumber / (steps.length - 1)) * 100;
  const activeStep = steps[activeStepNumber];
  const lastStep = activeStepNumber == steps.length - 1;

  if (step === TRIAL_SIGNUP_ROUTES.PAYMENT_DETAILS && hidePlanDetails)
    return null;

  return (
    <div className="circular-steps-indicator">
      <CircularProgressbar
        value={percentage}
        text={`${activeStepNumber + 1} of ${steps.length}`}
        strokeWidth={7}
        className="circular-indicator mr-3"
      />
      <div className="steps-name">
        <h5>{activeStep.stepName}</h5>
        {!lastStep && (
          <p className="mb-0">Next: {steps[activeStepNumber + 1].stepName}</p>
        )}
      </div>
    </div>
  );
};

export default CircularStepIndicator;



// WEBPACK FOOTER //
// ./src/components/transactions/CircularStepsIndicator.js